import React, { Component } from 'react'
import {AuthContext} from '../Firebase/AuthProvider'
import { getFollowingUserDetail } from '../Firebase/Users'
import { FIELDS } from '../Firebase/Constants'
import ImageComponent from './ImageComponent'
import Helper from '../Helper/helper'
import { Link } from "react-router-dom";

class FollowerList extends Component {
    static contextType = AuthContext
    constructor(props){
        super(props)
        this.state={
            userDetailLength:0,
            userFollowersDetail:[]
        }
    }

    componentDidMount(){
        if(this.state.userFollowersDetail.length <= 0){
            if(this.props.profile){
                this.getUserFollowerDetail(this.props?.userDetail).then(data=>{
                    this.setState({
                        userFollowersDetail:data[FIELDS.USER.USER_FOLLOWER_DETAIL]
                    })
                })
            }else{
                this.getUserFollowerDetail(this.context.state.userDetail).then(data=>{
                    this.setState({
                        userFollowersDetail:data[FIELDS.USER.USER_FOLLOWER_DETAIL]
                    })
                })
            }
        }
    }

    componentWillUnmount() {
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state,callback)=>{
            return;
        };
    }

    componentDidUpdate(prevProps, prevState) {
        let userDetail = prevProps.profile ? prevProps.userDetail : this.context.state.userDetail 
        if(userDetail[FIELDS.USER.USER_FOLLOWERS]?.length !== prevState.userDetailLength){
            this.setState({
                userDetailLength:userDetail[FIELDS.USER.USER_FOLLOWERS]?.length,
            })
            this.getUserFollowerDetail(userDetail).then(data=>{
                this.setState({
                    userFollowersDetail:data[FIELDS.USER.USER_FOLLOWER_DETAIL]
                })
            })
        }
        return 
    }

    getUserFollowerDetail = async(data)=>{
        const detail = await getFollowingUserDetail(data)
        return detail
    }

    render() {
        return (
            <div className="follower-list">
                {this.props.profile ?(
                    // <p>Who's following {this.props?.userDetail?.[FIELDS.USER.USER_NAME].split(" ")[0]} ({this.props?.userDetail?.[FIELDS.USER.USER_FOLLOWERS]?.length})</p>
                    <p>Followers ({this.props?.userDetail?.[FIELDS.USER.USER_FOLLOWERS]?.length})</p>
                ):(
                    <p>Followers ({this.context.state.userDetail[FIELDS.USER.USER_FOLLOWERS]?.length}</p>
                    // <p>Who's following you ({this.context.state.userDetail[FIELDS.USER.USER_FOLLOWERS]?.length})</p>
                )}
                <ul className="follower-ul mb-0">
                    {this.state.userFollowersDetail?.length > 0 && this.state.userFollowersDetail.slice(0, 8).map((user,key)=>{
                        return user && (
                            <li key={key}><span><Link to={`/profile/${user[FIELDS.USER.USER_ID]}`}><ImageComponent image={user[FIELDS.USER.USER_IMAGE]} /></Link></span>
                            <span className="name-follower">{Helper.transformText(user[FIELDS.USER.USER_NAME].split(" ")[0])}</span>
                            </li>
                        )
                    })}
                </ul>
            </div>
        )
    }
}

export default FollowerList
